import React, { useEffect, useState } from 'react';
import Header from '../components/HomePage/header';
import Footer from '../components/HomePage/footer';
import NewsletterPopup from '../Account/NewsletterPopup';
import LastestPosts from './Latestpost';
import Jumbotron from './Jumbotron';
import FeaturedPosts from './FeaturedPost';
import PrepnexaNews from './PrepNexaNews';
import { Helmet } from "react-helmet";


export default function BlogHomePage() {
  const [latestPosts, setLatestPosts] = useState([]);
  const [featuredPosts, setFeaturedPosts] = useState([]);
  const [newsPosts, setNewsPosts] = useState([]);
  const [error, setError] = useState(null);

  const fetchPosts = async (params, setState) => {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await fetch(`/api/posts?${queryParams}`);
      if (!response.ok) {
        throw new Error(`Failed to fetch posts: ${response.statusText}`);
      }
      const data = await response.json();
      setState(data.posts);
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    // Fetch latest posts
    fetchPosts(
      { status: 'published', sortBy: 'createdAt', order: 'desc', limit: 5, page: 1 },
      setLatestPosts
    );

    // Fetch featured posts
    fetchPosts(
      { status: 'published', category: 'Featured', sortBy: 'createdAt', order: 'desc', limit: 5, page: 1 },
      setFeaturedPosts
    );

    // Fetch news posts
    fetchPosts(
      { status: 'published', category: 'News', sortBy: 'createdAt', order: 'desc', limit: 5, page: 1 },
      setNewsPosts
    );
  }, []);

  return (
    <>
        <Helmet>
        <title>PrepNexis Blog – AI-Powered PTE Practice Platform</title>
        <meta
          name="description"
          content="Read expert tips, strategies, and AI insights to help you ace the PTE exam. Updated regularly with AI-powered learning techniques and real success stories."
        />
        <meta
          name="keywords"
          content="PTE blog, PrepNexis, PTE practice, AI mock tests, PTE preparation, PTE tips"
        />
      </Helmet>
      <Header />
      <Jumbotron />
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <LastestPosts posts={latestPosts} />
      <FeaturedPosts posts={featuredPosts} />
      <PrepnexaNews posts={newsPosts} />
      <NewsletterPopup />
      <Footer />
    </>
  );
}
